import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

enum TagSize {
  STANDARD = 'standard-size-variant',
  SMALL = 'small-size-variant',
}

enum TagColorVariants {
  YELLOW = 'yellow-variant',
  ORANGE = 'orange-variant',
  RED = 'red-variant',
  PINK = 'pink-variant',
  PURPLE = 'purple-variant',
  TEAL = 'teal-variant',
  BLUE = 'blue-variant',
  GREEN = 'green-variant',
  GREY = 'grey-variant',
}
enum TagVariants {
  READONLY = 'read-only',
  DISMISSABLE = 'dismissable',
  OPERATIONAL = 'operational',
  SELECTABLE = 'selectable',
}
@Component({
  selector: 'sl-tag',
  standalone: true,
  templateUrl: './sl-tag.component.html',
  styleUrls: ['./sl-tag.component.scss'],
  imports: [CommonModule],
})
export class SlTagComponent implements OnInit {
  //Declarations
  @Input() label!: string;
  @Input() icon?: string;
  @Input() size?: TagSize = TagSize.STANDARD;
  @Input() variant?: TagVariants = TagVariants.READONLY;
  @Input() color?: TagColorVariants = TagColorVariants.BLUE;
  @Input() operationalContent?: string[] = [];
  @Output() dismissEvent = new EventEmitter<void>();
  @Output() selectEvent = new EventEmitter<boolean>();

  openDropdown = false;
  isTagSelected = false;
  cssTagClassList: (TagColorVariants | string | undefined)[] = [];
  cssIconClass:
    | 'material-symbols-outlined-standard'
    | 'material-symbols-outlined-small' = 'material-symbols-outlined-standard';
  ngOnInit(): void {
    if (this.size === TagSize.SMALL) {
      this.cssIconClass = 'material-symbols-outlined-small';
    }
    this.cssTagClassList.push(this.color);
    if (this.variant === TagVariants.SELECTABLE) {
      this.cssTagClassList.push('selectable-tag');
    } else if (this.variant !== TagVariants.READONLY) {
      this.cssTagClassList.push(this.color + '-hover');
    }
  }
  dismissClickHandler() {
    this.dismissEvent.emit();
  }

  tagClickHandler() {
    if (this.variant === TagVariants.DISMISSABLE) {
      return;
    } else if (this.variant === TagVariants.SELECTABLE) {
      this.isTagSelected = !this.isTagSelected;
      if (this.isTagSelected) {
        this.cssTagClassList = ['selectable-tag-active'];
      } else {
        this.cssTagClassList = ['selectable-tag'];
      }
      this.selectEvent.emit(this.isTagSelected);
    } else if (this.variant === TagVariants.OPERATIONAL) {
      this.openDropdown = !this.openDropdown;
      if (this.openDropdown) {
        this.cssTagClassList = [this.color + '-operational-active'];
      } else {
        this.cssTagClassList = [this.color, this.color + '-hover'];
      }
    }
  }

  keyDownDismissHandler(event: KeyboardEvent) {
    const spc = event.key === ' ';
    const enter = event.key === 'Enter';
    if (spc || enter) {
      this.dismissClickHandler();
    }
  }
}
